/**
 * Enumerates auto generated header options
 * default option generates a non-sticky header row
 *
 * @public
 */
export var GenerateHeaderOptions;
(function (GenerateHeaderOptions) {
    GenerateHeaderOptions["none"] = "none";
    GenerateHeaderOptions["default"] = "default";
    GenerateHeaderOptions["sticky"] = "sticky";
})(GenerateHeaderOptions || (GenerateHeaderOptions = {}));
/**
 * Enumerates possible cell types.
 *
 * @public
 */
export var DataGridCellTypes;
(function (DataGridCellTypes) {
    DataGridCellTypes["default"] = "default";
    DataGridCellTypes["columnHeader"] = "columnheader";
    DataGridCellTypes["rowHeader"] = "rowheader";
})(DataGridCellTypes || (DataGridCellTypes = {}));
/**
 * Enumerates possible row types
 *
 * @public
 */
export var DataGridRowTypes;
(function (DataGridRowTypes) {
    DataGridRowTypes["default"] = "default";
    DataGridRowTypes["header"] = "header";
    DataGridRowTypes["stickyHeader"] = "sticky-header";
})(DataGridRowTypes || (DataGridRowTypes = {}));
